import { NewProduct, Product } from "models/common"

import { Paginated } from "./types"
import { StartWeekDay } from "models/agency"
import { http } from "./http"

export const fetchProducts = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("products", { searchParams }).json()
  return res as Paginated<Product>
}

export const createProducts = async (pld: NewProduct) => {
  const json = pld
  const res = await http.post("products", { json }).json()
  return res as Product
}

export const patchProduct = async (pld: {
  id: string
  clientId: string
  name?: string
  code?: string
  division?: string
  startWeekDay?: StartWeekDay
}) => {
  const { id, clientId, name, code, division, startWeekDay } = pld
  const res = await http.patch(`products/${id}`, {
    json: { clientId, name, code, division, startWeekDay },
  })
  return res
}

export const handleDeleteProduct = async (id: string) =>
  await http.delete(`products/${id}`)
